import { RowDataTerms } from "../../components/TermsPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the TermsRow factory
 */
class TermsRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/terms-conditions/read-range"
        this.accessData = "terms"
    }

    create(terms: any): RowDataTerms {
        const rowDataTerms: RowDataTerms = {
            id: terms.id,
            title: terms.title,
            content: terms.content,
            action: "",
        };
        return rowDataTerms;
    }
}

let termsRow: TermsRow | null = null;

export default function getTermsRow(): TermsRow {
    if (termsRow === null)
        termsRow = new TermsRow()
    return termsRow
}